
    import { Component, Vue, Prop } from "vue-property-decorator";

    @Component({
    })
    export default class SaveMsgPopUp extends Vue {

        @Prop()
        msgValue: any;

        @Prop()
        classFlag: any;

        calssName: string = "";
        iconName: string = "";

        created() {
            if (this.classFlag == 'success') {
                this.calssName = 'neu-snackbar--success';
                this.iconName = 'check_circle';
            }
            else if (this.classFlag == 'error') {
                this.calssName = 'neu-snackbar--error';
                this.iconName = 'error';
            }
        }

        mounted() {
            let vm = this;
            setTimeout(function () { vm.closeButtonClicked() }, 3000);
        }

        closeButtonClicked() {
            this.$emit('closeModal')
        }
    }

